import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  IKeyValueInterface,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  Entity
} from '../../shared/config';
import { AdminOfInstanceService } from '../models/admin-of-instance.service';
import { AdminOfInstanceModel } from '../models/admin-of-instance.model';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { retry } from 'rxjs/operator/retry';
import { PersonService } from '../../person/models/person.service';
import { InstanceService } from '../../instance/models/instance.service';
import { InstanceAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';
import { ModalDirective } from 'ng2-bootstrap/components/modal';

@Component({
  selector: 'wego-admin-of-instance',
  template: require('../views/admin-of-instance-list.component.html'),
  providers: [AdminOfInstanceService, PersonService, InstanceService]
})
export class AdminOfInstanceListComponent implements OnInit {
  addInstanceAdminLink: any;
  inviteTitle: any;
  roleAvailabilityList: RoleAvailabilityModel[];
  DataListModel: DataListModel;
  sub: any;
  instanceHashId: string;
  instanceAdminList: AdminOfInstanceModel[];
  errorModel: IKeyValueInterface[];
  roleColumns: number = 0;
  ToggleRoleName: string;
  ToggleUserName: string;
  ToggleAddRole: boolean;
  ToggleRoleHashId: string;
  ToggleRolePersonHashID: string;
  toggleRoleMsg: string;
  toggleRoleTitle: string;
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  instanceName: string;
  urlDefaultPage: string;
  urlInstanceList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  blockUnblockMsg: string;
  blockUnblockCompanyAdminHashId: string;
  blockMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private instanceList: string;
  adminDependencyvalidationMessage: string;
  adminDependencyModelTitle: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('adminDependencyModal') public adminDependencyModal: any;
  @ViewChild('adminDependencyValidationModal')
  public AdminDependencyValidationModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('toggleRolePopup') public toggleRolePopup: any;
  @ViewChild('inviteAdminModal') public inviteAdminModal: any;

  constructor(
    private adminOfInstanceService: AdminOfInstanceService,
    private personService: PersonService,
    private instanceService: InstanceService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) { }

  get isAnyChecked(): boolean {
    if (this.instanceAdminList) {
      let isCheck = this.instanceAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.instanceAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.instanceAdminList) {
      return this.instanceAdminList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.module = this.translate.instant('LblInstanceAdmin');
    this.adminDependencyModelTitle = this.translate.instant(
      'LblAdminDependencyAlert'
    );
    this.adminDependencyvalidationMessage = this.translate.instant(
      'LblAdminDependencyValidation'
    );
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.instanceList = this.translate.instant('LblListPage', [
      this.translate.instant('LblInstance')
    ]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ['userName', 'firstName', 'lastName'];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlInstanceList = this.authService.GetURL(
      ApplicationRouteURL.URL_INSTANCE_LIST
    );
    this.inviteTitle =
      this.translate.instant('LblInvite') +
      ' ' +
      this.translate.instant('LblInstanceAdmin');
    this.sub = this.activeRoute.params.subscribe(params => {
      this.instanceHashId = params['id'] || '';
      if (this.instanceHashId != '') {
        this.addInstanceAdminLink = new WeGoAuthorizedLink(
          '',
          Permission.PR_INSTANCE_ADMIN_OVERVIEW,
          PermissionType.INSERT,
          'btn btn-highlight navbar-right',
          'LblInvite',
          Entity.INSTANCE,
          this.instanceHashId
        );

        this.GetInstanceDetails();
      }
    });
  }

  public SuccessAdminDependencyModalClick() {
    this.adminDependencyModal.hide();
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.instanceHashId) {
      this.adminOfInstanceService
        .GetAllRoleAvailability(new DataListModel(), this.instanceHashId)
        .subscribe(
          res => {
            this.roleAvailabilityList = res.data;
            this.roleColumns = this.roleAvailabilityList.length;
            this.GetAdminOfInstanceList();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public GetInstanceDetails() {
    if (this.instanceHashId) {
      this.isLoading = true;
      this.instanceService
        .GetInstanceBasicDetail(this.instanceHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.instanceName = res.data.entityName;
              this.RoleAvailabilityList();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  
  

  public GetAdminOfInstanceList() {
    this.isLoading = true;
    this.adminOfInstanceService
      .GetAdminOfInstanceList(this.instanceHashId, this.DataListModel)
      .subscribe(
        res => {
          this.instanceAdminList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.instanceAdminList = [];
          this.DataListModel.infoMessage = error;
          this.isLoading = false;
        }
      );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminOfInstanceList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetAdminOfInstanceList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminOfInstanceList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminOfInstanceList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.adminOfInstanceService
      .ExportAdminOfInstanceList(this.instanceHashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = 'InstanceAdmin' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public DeleteAdminOfInstance(deleteInstanceAdminList: string[]) {
    this.isLoading = true;
    this.adminOfInstanceService
      .DeleteAdminOfInstance(this.instanceHashId, deleteInstanceAdminList)
      .subscribe(
        res => {
          if (!res.data) {
            this.adminDependencyvalidationMessage = this.translate.instant(
              'LblAdminDependencyValidationOnDelete'
            );
            this.adminDependencyModal.show();
            this.isLoading = false;
          } else {
            this.DataListModel.currentPage = 1;
            this.GetAdminOfInstanceList();
            this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
              this.module
            ]);
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnParentCheck(isChecked: boolean) {
    this.instanceAdminList
      .filter(x => x.isDeletable)
      .forEach(x => (x.isChecked = isChecked));
  }

  public ShowAlertModal(deletePersonMasterHashId?: string): void {
    if (deletePersonMasterHashId) {
      this.deleteMessage = this.translate.instant(
        'LblRecordDeleteConfirmation',
        [this.module]
      );
      this.isMultipleDelete = false;
      this.deletePersonMasterHashId = deletePersonMasterHashId;
    } else {
      this.deleteMessage = this.translate.instant(
        'LblRecordMultiplDeleteConfirmation',
        [this.module]
      );
      this.isMultipleDelete = true;
    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletePersonMasterHashId = '';
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteAdminOfInstanceList: any[];
    if (this.isMultipleDelete)
      deleteAdminOfInstanceList = this.instanceAdminList
        .filter(x => x.isChecked)
        .map(x => x.personMasterHashId);
    else deleteAdminOfInstanceList.push(this.deletePersonMasterHashId);

    this.DeleteAdminOfInstance(deleteAdminOfInstanceList);
    this.alertModal.hide();
  }

  // Add Instance admin popup
  public ShowAddInstanceAdminModal() {
    this.ShowInviteAdminModal();
  }

  public ToggleRoleAvailibility(
    personHashID: string,
    roleHashId: string,
    personRolesHashIds: string[],
    roleName: string,
    userName: string
  ) {
    this.ToggleRolePersonHashID = personHashID;
    this.ToggleRoleHashId = roleHashId;
    this.ToggleUserName = userName;
    this.ToggleRoleName = roleName;

    if (this.CheckRole(personRolesHashIds, roleHashId)) {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [
        userName,
        roleName
      ]);
      this.ToggleAddRole = false;
      this.ShowToggleRolePopup();
    } else {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [
        userName,
        roleName
      ]);
      this.ToggleAddRole = true;
      this.ShowToggleRolePopup();
    }
  }

  public ShowToggleRolePopup(): void {
    this.toggleRolePopup.show();
  }

  public HideToggleRolePopup(): void {
    this.ToggleRolePersonHashID = '';
    this.ToggleRoleHashId = '';
    this.ToggleUserName = '';
    this.ToggleRoleName = '';

    this.toggleRolePopup.hide();
  }

  public ConfirmToggleRolePopup(): void {
    if (this.ToggleAddRole) {
      this.adminOfInstanceService
        .AddAdminOfInstanceRole(
          this.instanceHashId,
          this.ToggleRolePersonHashID,
          this.ToggleRoleHashId
        )
        .subscribe(
          res => {
            this.GetAdminOfInstanceList();
            this.popupMsg = this.translate.instant('LblRoleAddedSuccess', [
              this.ToggleUserName,
              this.ToggleRoleName
            ]);
            this.HideToggleRolePopup();
            this.ShowSuccessPopup();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          }
        );
    } else {
      this.adminOfInstanceService
        .DeleteAdminOfInstanceRole(
          this.instanceHashId,
          this.ToggleRolePersonHashID,
          this.ToggleRoleHashId
        )
        .subscribe(
          res => {
            if (!res.data) {
              this.HideToggleRolePopup();
              this.adminDependencyvalidationMessage = this.translate.instant(
                'LblAdminDependencyValidation'
              );
              this.adminDependencyModal.show();
            } else {
              this.GetAdminOfInstanceList();
              this.popupMsg = this.translate.instant('LblRoleDeletedSuccess', [
                this.ToggleUserName,
                this.ToggleRoleName
              ]);
              this.HideToggleRolePopup();
              this.ShowSuccessPopup();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          }
        );
    }
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = '';
    this.resetPasswordModal.hide();
  }
  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    console.log(this.resetPasswordPersonHashId);
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailFailure'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ShowInviteAdminModal(): void {
    this.inviteAdminModal.availableRoles = JSON.parse(
      JSON.stringify(this.roleAvailabilityList)
    );
    this.inviteAdminModal.availablePersons = '';
    this.inviteAdminModal.show();
  }

  public HideInviteAdminModal(): void {
    this.inviteAdminModal.hide();
  }

  public SuccessInviteAdminModalClick($event: any): void {
    let adminInvitation = new InstanceAdminInvitationModel();
    adminInvitation.emailAddress = $event.emailAddress;
    adminInvitation.personHashId = $event.personHashId;
    adminInvitation.roleHashIdList = $event.roleHashIdList;
    adminInvitation.instanceHashId = this.instanceHashId;

    this.adminOfInstanceService
      .InviteAdminOfInstance(adminInvitation)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblInvitationMailSuccess');
            this.HideInviteAdminModal();
            this.ShowSuccessPopup();
          } else {
            this.inviteAdminModal.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideInviteAdminModal();
        }
      );
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.adminOfInstanceService
      .GetPersonListToInvite(this.instanceHashId, emailAddress)
      .subscribe(
        res => {
          if (res.data) {
            this.inviteAdminModal.availablePersons = res.data;
            this.inviteAdminModal.errorModel = [];
          } else {
            this.inviteAdminModal.errorModel = res.error;
          }
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public CheckRole(existingArray: string[], currentRole: string) {
    return existingArray.some(x => x == currentRole);
  }

  get isResetCookieAccess(): boolean {
    if (this.instanceAdminList) {
      return this.instanceAdminList.some(x => !x.twoFaDisabled);
    } else {
      return false;
    }
  }

  get isTwoFaResetKeyAccess(): boolean {
    if (this.instanceAdminList) {
      return this.instanceAdminList.some(x => x.resetKeyEnabled);
    } else {
      return false;
    }
  }

  public ResetPersonCookies(personHashID: string) {
    ;
    this.personService.ResetTwoFaCookie(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblCookieResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblCookieResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonTwoFA(personHashID: string) {

    this.personService.ResetTwoFaKey(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblKeyResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblKeyResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-instance/components/admin-of-instance-list.component.ts